import { List, ListItemButton, ListItemIcon, ListItemText } from "@mui/material"
import { useCallback } from "react"
import { useNavigate } from "react-router-dom"
import AdminMenuObject from "shared/admin-menu"
import styles from "./navigation.module.css"

interface TAdminMenuDescription {
    name: string
    link: string
    submenu?: TAdminMenuDescription[]
    icon: string
}

export const Navigation = () => {
    const navigate = useNavigate()

    const makeAdminUI = useCallback((description: TAdminMenuDescription[]) => {
        return description.map((el: TAdminMenuDescription) => {
            const isSelected = "/" + location.pathname.split('/').at(1) === el.link;
            return (
                <ListItemButton
                    key={el.link}
                    onClick={() => { navigate(el.link || '') }}
                    selected={isSelected}
                >
                    <ListItemIcon>
                        <img src={el.icon} alt={'NoImg'}/>
                    </ListItemIcon>
                    <ListItemText>{el.name}</ListItemText>
                </ListItemButton>
            )
        })
    }, [])

    const menuUi = makeAdminUI(AdminMenuObject())

    return (
        <div className={styles.App}>
            <div>Ссылки</div>
            <List>
                {menuUi}
            </List>
        </div>
    )
}